    <template>
        <div class="sw-modal edit-form-component">
            <div v-click-outside="cancel" class="sw-modal-content">
                <div class="row sw-modal-heading">
                    <div class="col"><h4><i class="fas fa-concierge-bell"></i>Edit Front Desk site</h4></div>
                </div>
                <div class="sw-modal-body">
                    <div class="row question">
                        <div class="col-12">
                            A front desk site allows your reception staff to quickly get guests to fill in a
                            check-in form (or any other form) of your choice and design.
                        </div>
                    </div>
                    <div class="row question">
                        <div class="col-12 question__question">
                            Personalised URL
                        </div>
                        <div class="col-12 sw-modal-explanation">
                            Secure your personalised URL for your front desk site
                        </div>
                        <div class="col-12 question__input--flex">
                            <span class="edit-establishment__front-desk-url-prefix">{{getFrontDeskBaseURL()}}/front-desk/</span><input type="text" v-model="copy.preferences.frontDeskPath" class="short-question short-question--remaining-space">
                            <div class="tooltip-container"><i v-on:click="copyURL" class="fa fa-copy edit-establishment__front-desk-copy-url"></i><span class="tooltip-text tooltip-text--left" v-bind:class="{'tooltip-visible' : showLinkCopied}">URL copied</span></div>
                            <a v-bind:href="getURL" target="_blank">
                                <i class="fas fa-external-link-alt edit-establishment__front-desk-open-url"></i>
                            </a>
                        </div>
                    </div>
                    <div class="row question">
                        <div class="col-12 question__question">
                            Background image
                        </div>
                        <div class="col-12 sw-modal-explanation">
                            Click on the image to use as the background on your front desk web page
                        </div>
                        <div class="col-12">
                            <div v-for="(image, index) in copy.preferences.images"
                                 v-bind:key="index"
                                 v-on:click="selectBackgroundImage(image.reference)"
                                 class="edit-establishment__images-thumbnail edit-establishment__images-thumbnail--selectable"
                                 v-bind:class="{'edit-establishment__images-thumbnail--selected' : image.reference === copy.preferences.frontDeskBackgroundImage}">
                                <img v-bind:src="image.url"/>
                                <div v-if="image.reference === copy.preferences.frontDeskBackgroundImage"><i class="fas fa-check"></i></div>
                            </div>
                        </div>
                    </div>
                    <div class="row question">
                        <div class="col-12 question__question">
                            Page title
                        </div>
                        <div class="col-12 sw-modal-explanation">
                            Edit the title for the page.
                        </div>
                        <div class="col-12">
                            <input type="text" v-model="copy.preferences.frontDeskTitle" class="short-question">
                        </div>
                    </div>
                    <div class="row question">
                        <div class="col-12 question__question">
                            Button text
                        </div>
                        <div class="col-12 sw-modal-explanation">
                            Edit the button text for the page.
                        </div>
                        <div class="col-12">
                            <input type="text" v-model="copy.preferences.frontDeskCTA" class="short-question">
                        </div>
                    </div>
                    <div class="row question">
                        <div class="col-12 question__question">
                            Choose a 4 to 6 digit security PIN
                        </div>
                        <div class="col-12 sw-modal-explanation">
                            The site is locked after 5 minutes of inactivity for security reasons.
                        </div>
                        <div class="col-12">
                            <input type="text" v-model="copy.preferences.frontDeskPIN" class="short-question">
                        </div>
                    </div>
                </div>
                <div class="sw-modal-actions">
                    <div v-if="updating || error" class="infobar" v-bind:class="{'infobar-info' : !error, 'infobar-error' : error}">
                        {{infoMessage}}
                    </div>
                    <div v-show="updating && !success">
                        <Spinner/>
                    </div>
                    <div class="row" v-show="!updating && !success">
                        <div class="col text-center">
                            <button class="btn btn-secondary" v-on:click="cancel">Cancel</button>
                            <button class="btn btn-primary" v-on:click="save">Save</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </template>

<script>
    import { store } from '../../store.js'
    import Spinner from '../Spinner.vue'

    export default {
        name: 'EditFrontDesk',
        components: {
            Spinner
        },
        props: {
            establishment: Object
        },
        data: function() {
            return {
                copy: {
                    preferences: {
                        frontDeskPath: "",
                        frontDeskTitle: "",
                        frontDeskCTA: "",
                        frontDeskPIN: "",
                        frontDeskBackgroundImage: "",
                    }
                },
                showLinkCopied: false,
                updating: false,
                error: false,
                success: false,
                infoMessage: "",
                uploadFieldName: 'photos'
            }
        },
        computed: {
            getURL: function() {
                return this.getFrontDeskBaseURL() + '/front-desk/' + this.copy.preferences.frontDeskPath;
            }
        },
        methods: {
            reset: function() {
                // reset form to initial state
                this.infoMessage = null;
            },
            cancel: function() {
                console.log("cancel");
                // this.establishment.name = this.copy.name;
                this.$root.$emit('finished-editing-establishment-front-desk');
            },
            getFrontDeskBaseURL: function() {
                return process.env.VUE_APP_GUEST_BASE_URL;
            },
            copyURL: function() {
                console.log("copying Front Desk URL");
                const el = document.createElement('textarea');
                el.value = this.getURL;
                console.log("copying URL: " + el.value);
                document.body.appendChild(el);
                el.select();
                document.execCommand('copy');
                document.body.removeChild(el);
                this.showLinkCopied = true;
                setTimeout(() => {
                    this.showLinkCopied = false;
                }, 2000);
            },
            selectBackgroundImage: function(imageReference) {
                if (this.copy.preferences.frontDeskBackgroundImage === imageReference) {
                    this.copy.preferences.frontDeskBackgroundImage = null;
                } else {
                    this.copy.preferences.frontDeskBackgroundImage = imageReference;
                }
            },
            save: function() {
                console.log("saving establishment");
                this.error = false;

                let body = {
                    "reference": this.copy.reference,
                    "preferences": {
                        "frontDeskPath": this.copy.preferences.frontDeskPath,
                        "frontDeskTitle": this.copy.preferences.frontDeskTitle,
                        "frontDeskCTA": this.copy.preferences.frontDeskCTA,
                        "frontDeskPIN": this.copy.preferences.frontDeskPIN,
                        "frontDeskBackgroundImage": this.copy.preferences.frontDeskBackgroundImage,
                        // this is here, so that we don't remove it by leaving it null
                        "logo": this.copy.preferences.logo,
                    }
                };
                console.log(body);

                // updating a form template
                this.updating = true;
                this.infoMessage = "Saving establishment";
                this.$http.put('/guest-management/v1/establishments/' + store.currentEstablishmentReference, body
                ).then(response => {
                    console.log("Establishment updated:");
                    console.log(response);
                    this.infoMessage = "Establishment updated";
                    this.success = true;
                    Object.assign(this.establishment, this.copy);
                    setTimeout(() => {
                        this.updating = false;
                        this.$root.$emit('finished-editing-establishment-front-desk');
                    }, 2000);
                }).catch(error => {
                    this.error = true;
                    this.updating = false;
                    if (error.response) {
                        this.infoMessage = "Error: " + error.response.data.message
                    } else {
                        this.infoMessage = "Error updating establishment";
                    }
                });
            }
        },
        mounted() {
            this.reset();
            this.copy = { ...this.establishment };
            this.copy.preferences = { ...this.establishment.preferences };
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/components/modal";
    @import "../../styles/components/edit_establishment";
    @import "../../styles/components/question_answer";
    @import "../../styles/layout/tooltips";
</style>